import React from 'react';
import '../App.css';

export default function Servicespage() {
  return <h1 className='servicespage'>SERVICES</h1>;
}
